module.exports = __webpack_public_path__ + "img/pr-26.a7f402b1.png";